import React, { useContext, useEffect, useState } from 'react'
import Modal from '../../../../common/modal/Modal'
import Button from '../../../../common/button/Button';
import { 
  addMemberModalId, 
  errorMessage, 
  getStrengthColor, 
  getStrengthLabel, 
  inputError, 
  isEmailExistInArray, 
  isIterable, 
  isValidEmail, 
  membersArray, 
  queryClient, 
  validatePassword 
} from './Utils';
import { performRequest } from '../../../../common/utils';
import { useQuery } from '@tanstack/react-query';
import MicroModal from 'micromodal';
import { useGroupDashboardContext } from '../../GroupDashboardContext';
import { useNavigate } from 'react-router-dom'

const AddMemberModal = ({
  modalOption = 'automatic',
  isAdmin = false,
  teamTitle = '',
  teamId,
  refetchAdded = null, 
  refetchInvited = null,
  navigateTo = ''
}) => {

  const modalId = addMemberModalId(teamId)
  const { selectedAddMemberModal } = useGroupDashboardContext()

  const [ submitAttempted, setSubmitAttempted ] = useState(false)
  const [ saveMemberResponse, setSaveMemberResponse ] = useState('')
  const [ submitOption, setSubmitOption ] = useState(modalOption)
  const [ responseTeamId, setResponseTeamId ] = useState('')
  const [ members, setMembers ] = useState([membersArray()])
  const isSameTeamId = parseInt( selectedAddMemberModal?.teamId ) === parseInt( responseTeamId ) ? true : false
  const navigate = useNavigate()

  const handleInputValidation = ( index, event ) => {
    const { name, value } = event.target
    const newMembers = [...members]

    const isEmpty = () => {
      if( ! value.trim() ){
        newMembers[index][name].error = true
        newMembers[index][name].message = errorMessage.required
      } else { 
        newMembers[index][name].error = false
        newMembers[index][name].message = ''
      }
    }

    const passwordValidation = () => {
      const strengthLabel = getStrengthLabel( validatePassword( value ) )
      const strengthLevel = validatePassword( value )
      if( ! value.trim() ){
        newMembers[index][name].error = true
        newMembers[index][name].message = errorMessage.required
        newMembers[index].strength = ''
      } else if( strengthLevel < 3 ){
        newMembers[index][name].error = true
        newMembers[index][name].message = ''
        newMembers[index].strength = strengthLabel
      } else {
        newMembers[index][name].error = false
        newMembers[index][name].message = ''
        newMembers[index].strength = strengthLabel
      }
    }

    const emailValidation = () => {
      if( ! value.trim() ){
        newMembers[index][name].error = true
        newMembers[index][name].message = errorMessage.required
      } else if( ! isValidEmail( value ) ){
        newMembers[index][name].error = true
        newMembers[index][name].message = errorMessage.validEmail
      } else if( isEmailExistInArray( members, value, index ) ){
        newMembers[index][name].error = true
        newMembers[index][name].message = errorMessage.existEmail
      } else { 
        newMembers[index][name].error = false
        newMembers[index][name].message = ''
      }
    }

    switch (name) {
      case 'role':
      case 'username':
        isEmpty()
        break;
      case 'password':
        passwordValidation()
        break;
      case 'email':
        emailValidation()
        break;
    }

    newMembers[index][name].value = value
    setMembers(newMembers)

  }

  const handleInputColorStatus = ( isError, hasMessage ) => {
    const res = isError === true && hasMessage !== '' ? 'error' : 'default'
    return `msync-input-status-${res}`
  }

  const addMember = () => {
    if ( selectedAddMemberModal.teamType === 'wooteams' ) {
      if( hasAvailableSeats( members.length ) ){
        setMembers([
          ...members,
          membersArray(),
        ])
      }
    } else if ( selectedAddMemberModal.teamType === 'msynclicenses' ) {
      setMembers([
        ...members,
        membersArray(),
      ])
    }
  }

  const hasAvailableSeats = ( maxLength = 0 ) => {
    return ( 
      ! selectedAddMemberModal.seatCount 
      || selectedAddMemberModal.remainingSeats > parseInt( maxLength ) ) 
    ? true
    : false
  }

  const removeMember = ( index, formIndex ) => {
    if( ! isFormIndexEmpty( formIndex ) ){
      const result = window.confirm("Are you sure you want to remove this member form index?")
      if( ! result ) return false
    }
    const newMembers = [...members]
    newMembers.splice(index, 1)
    setMembers(newMembers)
  }

  const resetForm = () => {
    setMembers([membersArray()])
  }

  const handleCloseModal = () => {
    if( ! isFormEmpty() ){
      const result = window.confirm("Are you sure you want to close the modal?")
      if( ! result ) return false
    }
    resetForm()
    MicroModal.close(modalId)
  }

  const isFormIndexEmpty = ( formIndex ) => {
    const hasValue = Object.values(formIndex).some(field => field.value)
    return !hasValue
  }

  const isFormEmpty = () => {
    const hasValue = members.some(member => (
      Object.values(member).some(field => field.value)
    ))
    return !hasValue
  }

  const isFormError = () => {
    const hasError = members.some(member => (
      Object.values(member).some(field => field.error)
    ))
    return hasError
  }

  const handleAddMembers = () => {
    setSubmitAttempted(true)
    if( isFormError() ) return
    refetch()
  }
  
  const { 
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['msync_save_members'],
      queryFn: request,
      refetchOnWindowFocus: false,
      enabled: false
    }, queryClient)

    async function request(){
      const formData = new FormData()
      formData.append('action', 'msync_save_members')
      formData.append('submit_option', submitOption)
      formData.append('team_id', teamId)
      formData.append('team_type', selectedAddMemberModal.teamType)
      formData.append('members', JSON.stringify(members))
      formData.append('nonce', group_dashboard.nonce_members)
      try {
        // const perform = await performRequest(group_dashboard.ajaxurl, formData)
        // const res = await perform.json()
        const res = await Tangible?.ajax('msync_save_members', {
          team_id: teamId,
          team_type: selectedAddMemberModal.teamType,
          members: JSON.stringify(members),
          submit_option: submitOption
        })

        if( ! res.success ){
          setResponseTeamId(res.team_id)
          throw new Error( res.errors.shift() )
        }
        setResponseTeamId(res.team_id)
        const responseData = res.data
        const hasError = Object.values(responseData).flat().some(item => item.success === false)
        if( ! hasError ){
          resetForm()
          MicroModal.close(modalId)
          if( navigateTo ){ navigate( navigateTo ) }
          if( submitOption === 'automatic' && refetchAdded !== null ){ refetchAdded() }
          if( submitOption === 'invite' && refetchInvited !== null ){ refetchInvited() }
        }
        setSaveMemberResponse('')
        return responseData
      } catch (error) {
        console.error( error )
        setSaveMemberResponse( error.toString() )
        return false
      }
    }

  const checkSubmitOption = ( event ) => {
    setSubmitOption(event.target.value)
  }

  useEffect(() => {
    queryClient.setQueryData(['msync_save_members'], null);
  }, [])

  const modalHeading = `Add Members${teamTitle ? ` (${teamTitle})` : ''}`
  return (
    <>
      <Modal 
        modalId={modalId} 
        modalHeading={modalHeading}
        buttonTitle="" 
        modalClassNames={ hasAvailableSeats() ? 'msync-modal-custom' : 'msync-members-custom-modal msync-members-custom-modal-border'}
      >
        <main className="msync-modal__body msync-repeater-form">
          {
            hasAvailableSeats()
            ? <>
              {
                isSameTeamId && isError
                ? <div className='msync-save-members-response error'><span>{ error.message }</span></div>
                : saveMemberResponse && <div className='msync-save-members-response error'><span>{ saveMemberResponse }</span></div>
              }
              { members.map( ( member, index ) => (
                <div className="msync-repeater-form__item msync-grid-container">
                  {
                    isSameTeamId && data && Object.keys(data).map((email) => {
                      const items = data[email]
                      if (member.email.value === email) {
                        if (isIterable(items)) {
                          return (
                            <div key={email} className='msync-save-members-response error'>
                              <span>{items.length} {items.length <= 1 ? 'issue' : 'issues'} found in entry. Please resolve before submitting.</span>
                              <ul>
                                {items.map((value, key) => (
                                  <li key={key}>{value.message}</li>
                                ))}
                              </ul>
                            </div>
                          )
                        } else {
                          return (
                            <div key={email} className='msync-save-members-response success'>
                              <span>{items.message}</span>
                            </div>
                          )
                        }
                      }
                      return null
                    })
                  }
                  <div key={index} className="msync-form msync-repeater-form__item__body">
                    <div className="msync-form__body msync-grid">
                      <div className="msync-form__group">
                        <label>First Name</label>
                        <input
                          type="text"
                          name="firstName"
                          className={ handleInputColorStatus( member.firstName.error, member.firstName.message ) }
                          value={member.firstName.value}
                          placeholder="First name"
                          onChange={(e) => handleInputValidation(index, e)}
                          required
                        />
                        { inputError(member.firstName.message) }
                      </div>
                      <div className="msync-form__group">
                        <label>Last Name</label>
                        <input
                          type="text"
                          name="lastName"
                          className={ handleInputColorStatus( member.lastName.error, member.lastName.message ) }
                          value={member.lastName.value}
                          placeholder="Last name"
                          onChange={(e) => handleInputValidation(index, e)}
                        />
                        { inputError(member.lastName.message) }
                      </div>
                      <div className="msync-form__group">
                        <label className="msync-required">Role</label>
                        <select
                          name="role"
                          className={ handleInputColorStatus( member.role.error, member.role.message ) }
                          value={member.role.value}
                          onChange={(e) => handleInputValidation(index, e)}
                        >
                          <option value="">Select role</option>
                          <option value="member">Member</option>
                          <option value="manager">Manager</option>
                        </select>
                        { inputError(member.role.message) }
                      </div>
                      <div className="msync-form__group">
                          <label className="msync-required">Username</label>
                          <input
                              type="text"
                              name="username"
                              className={ handleInputColorStatus( member.username.error, member.username.message ) }
                              value={member.username.value}
                              onChange={(e) => handleInputValidation(index, e)}
                              placeholder="Username"
                              required
                          />
                          { inputError(member.username.message) }
                      </div>
                      <div className="msync-form__group">
                        <label className="msync-required">Email</label>
                        <input
                          type="email"
                          name="email"
                          className={ handleInputColorStatus( member.email.error, member.email.message ) }
                          value={member.email.value}
                          placeholder="Email"
                          onChange={(e) => handleInputValidation(index, e)}
                        />
                        { inputError(member.email.message) }
                      </div>
                      <div className="msync-form__group">
                        <label className="msync-required">Password</label>
                        <input
                          type="password"
                          name="password"
                          className={ handleInputColorStatus( member.password.error, member.password.message ) }
                          value={member.password.value}
                          placeholder="Password"
                          onChange={ (e) => handleInputValidation(index, e)}
                        />
                        { inputError(member.password.message) }
                        <div style={{ color: getStrengthColor(member.strength), fontSize: '0.8rem' }}>
                          <small>{ member.strength }</small>
                        </div>
                      </div>
                      <div className="msync-repeater-form__item__footer">
                        {
                          members.length > 1 &&
                          <Button
                          className="msync-button--is-style-outline msync-button--is-theme-destructive"
                            name="Remove"
                            onClick={() => removeMember(index, member)}
                          />
                        }
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="msync-repeater-form__footer">
                <Button
                  className="msync-button--is-style-outline"
                  name={ hasAvailableSeats( members.length ) ? 'Add another member' : 'No more seats left' }
                  onClick={() => addMember()}
                  disabled={ ! hasAvailableSeats( members.length ) }
                />
              </div>
              </>
            : <div className='msync-my'>
                <p> You can't add more members because there are no seats remaining on your team. </p>
              </div>
          }
        </main>
        {
          hasAvailableSeats() &&
          <footer className="msync-modal__footer">
          {
            isAdmin &&
            <div className="msync-flex msync-flex--wrap msync-margin-inline-end-auto msync-add-member-import-option">
              <div className="msync-inline-choice">
                <input type="radio" id={`automatically_add_members_${teamId}`} value="automatic" onChange={checkSubmitOption} checked={ submitOption === 'automatic' } />
                <label htmlFor={`automatically_add_members_${teamId}`}>Auto-add members</label>
              </div>
              <div className="msync-inline-choice">
                <input type="radio" id={`invite_members_${teamId}`} value="invite" onChange={checkSubmitOption} checked={ submitOption === 'invite' } />
                <label htmlFor={`invite_members_${teamId}`}>Invite members</label>
              </div>
            </div>
          }
          <Button
            className="msync-button--is-style-outline msync-button--is-theme-destructive"
            type="button"
            name="Cancel"
            onClick={ () => handleCloseModal() }
            aria-label="Close this dialog window"
          />
            <Button
              onClick={ () => handleAddMembers() }
              name={
                isLoading || isFetching 
                ? 'Loading...' 
                : submitOption === 'automatic' 
                ? 'Add Members' 
                : 'Invite Members'
              }
              disabled={ isFormError() || isLoading || isFetching ? true : false }
            />
          </footer>
        }
        
      </Modal>
    </>
  )
}

export default AddMemberModal
